import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const resetPasswordGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  const allowed =
    localStorage.getItem('reset_password_required') === 'true';

  if (!allowed) {
    router.navigate(['/login']);
    return false;
  }

  return true;
};
